import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsNetworkMerchantDetailSchema = withDefaults({
  type: 'pcs-network-merchant-detail',
  objectExtensions: ['pcs-network-merchant-detail'],
  fields: [
    {
      kind: 'attribute',
      name: 'dataProvider',
    },
    {
      kind: 'attribute',
      name: 'terminalId',
    },
    {
      kind: 'attribute',
      name: 'detail',
    },
    {
      kind: 'belongsTo',
      name: 'pcsNetworkMerchant',
      type: 'pcs-network-merchant',
      options: {
        async: false,
        inverse: 'pcsNetworkMerchantDetails',
      },
    },
  ],
});

export default PcsNetworkMerchantDetailSchema;
